<template>
  <svg class="logo" width="35" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0)">
      <path d="M11.0779 8.67844e-05L8.99953 3.69505L6.92113 8.67844e-05H-0.000244141L8.99953 15.9999L17.9993 8.67844e-05H11.0779Z" fill="#41B883"/>
      <path d="M11.0779 8.4877e-05L8.99948 3.69505L6.92107 8.4877e-05H3.59961L8.99948 9.5998L14.3993 8.4877e-05H11.0779Z" fill="#34495E"/>
      </g>
      <defs>
      <clipPath id="clip0">
      <rect width="18" height="16" fill="white"/>
      </clipPath>
      </defs>
  </svg>
</template>

<script>
export default {
  name: 'vue-icon'
}
</script>
<style>
.logo {
  fill: currentColor
}
</style>